import { render, staticRenderFns } from "./SendMessageExampleModal.vue?vue&type=template&id=4795916a&lang=pug"
import script from "./SendMessageExampleModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageExampleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports